<b3-modal [open]="true" overlay size="md" (b3-close)="close()">
  <b3-modal-header
    [heading]="title"
    aria-level="2"
    icon="check_circle"
    icon-tone="success"
    close-aria-label="Fechar"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <p class="transference-success-modal__description">{{ description }}</p>
    <p class="transference-success-modal__control-number" *ngIf="operationCode">
      Número de controle: <strong>{{ operationCode }}</strong>
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="transference-success-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        class="transference-success-modal__btn-new"
        (b3-click)="onNewTransference()">
        Nova Transferência
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        class="transference-success-modal__btn-consult"
        (b3-click)="onConsultOperation()">
        Consultar Operação
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
